import request from "@/utils/request";

/** 获取代理商订单分润列表 */
export function getAgentProfitList(data) {
  return request({
    url: "/agentOrder/getOrderDividendList",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/json"
    }
  });
}

/** 提现申请列表 */
export function getWithdrawApplyList(data) {
  return request({
    url: "/agentWithdraw/queryWithdrawHistory",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/json"
    }
  });
}

/** 分润导出  */
export function exportWithdrawApplyList(data) {
  return request({
    url: "/agentOrder/exportList",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    responseType: "blob", // 重要：设置responseType为'blob'以处理二进制数据
    data
  });
}

/** 提现导出 */
export function exportAgentProfitList(data) {
  return request({
    url: "/agentWithdraw/exportWithdrawHistory",
    method: "post",
    headers: {
      "Content-Type": "application/json"
    },
    responseType: "blob", // 重要：设置responseType为'blob'以处理二进制数据
    data
  });
}

/** 取消提现申请 */
export function cancelWithdrawApply(data) {
  return request({
    url: "/agentWithdraw/updateWithdrawInfo",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/json"
    }
  });
}

/** 查询代理商提现账户 */
export function getBankListQuery(params) {
  return request({
    url: "/agentWithdraw/queryWithdrawAccount",
    method: "get",
    params
  });
}

/** 添加代理商提现账户 */
export function addBankListQuery(data) {
  return request({
    url: "/agentWithdraw/agentWithdraw",
    method: "post",
    data,
    headers: {
      "Content-Type": "application/json"
    }
  });
}
// 查询代理TBC账户流水
export function getTbcAcctFlow(data) {
  return request({
    url: "/tbcWithdraw/getTbcAcctFlow",
    method: "get",
    params: data
  });
}
// 查询代理TBC提现记录
export function getTbcWithdrawList(data) {
  return request({
    url: "/tbcWithdraw/getTbcWithdrawList",
    method: "get",
    params: data
  });
}
